'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import {CheckIcon, MinusIcon} from 'lucide-react';

import {cn} from '@purpose/ui/lib/utils';

interface ICheckbox extends Omit<
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
  'onChange' | 'indeterminate'
> {
  onChange?: (checked: CheckboxPrimitive.CheckedState) => void;
  indeterminate?: boolean;
  reference?: React.Ref<any>;
  error?: boolean;
}

function Checkbox({
  className,
  onChange,
  indeterminate,
  reference,
  error,
  ...props
}: ICheckbox) {
  return (
    <CheckboxPrimitive.Root
      ref={reference}
      data-slot="checkbox"
      className={cn(
        'peer border-ring data-[state=checked]:text-primary-40-foreground data-[state=checked]:border-primary-40 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 h-[20px] w-[20px] shrink-0 rounded-[4px] border-2 bg-white outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        error && 'border-red-50',
        className
      )}
      onCheckedChange={onChange || props?.onCheckedChange}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        {indeterminate ? (
          <MinusIcon className="size-3.5" />
        ) : (
          <CheckIcon className="size-3.5" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export {Checkbox};
